<template>
  <div class="mainCard">
    <el-page-header
      :title="$t('common.goBack')"
      :content="null"
      @back="$router.push({
        name: 'myLeaderDetail',
        params: {
          id: $route.params.id,
        },
      })"
    />

    <Pulse
      v-if="pulse.pulse1 || pulse.pulse2 || pulse.pulse3"
      :pulse.sync="pulse"
      :pulse-report="pulseReport"
      :censor-check="censorCheck"
      :show-coworkers="true"
    />
  </div>
</template>

<script>
import api from '@/api';

import Pulse from '@/views/dashboard/content/leader/pulse/Pulse.vue';

export default {
  name: 'LeaderPulseInfo',

  components: {
    Pulse,
  },

  data: () => ({
    loading: false,
    pulse: {
      pulse1: null,
      pulse2: null,
      pulse3: null,
    },
    pulseReport: null,
  }),

  computed: {
    censorCheck() {
      let flag = false;

      if (this.pulse.pulse1 && this.pulse.pulse2) {
        flag = !this.pulse.pulse1.censor || !this.pulse.pulse2.censor;
      } else {
        flag = !this.pulse.pulse1.censor;
      }

      return flag;
    },
  },

  watch: {
    // eslint-disable-next-line func-names
    '$route.params.id': function () {
      this.init();
    },
  },

  created() {
    this.init();
  },

  methods: {
    init() {
      this.getPulseData();
      this.getPulseReport();
    },

    async getPulseData() {
      this.loading = true;
      try {
        const response = await api.getLeaderPulseData(this.$route.params.id);
        this.pulse = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async getPulseReport() {
      this.loading = true;
      try {
        const response = await api.getLeaderPulse(this.$route.params.id, { quick: true });
        this.pulseReport = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      } finally {
        this.loading = false;
      }
    },

    async extendPulse() {
      try {
        const response = await api.extendLeaderPulseSurvey(this.leaderUuid);
        this.pulse[this.selectedPulse] = response.data;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    emptyData() {
      this.pulse = {
        pulse1: null,
        pulse2: null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
//
</style>
